import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from "./auth.service";
import {environment} from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class IncomeGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {
  }

  canActivate(): boolean {

    const user = this.authService.user$.getValue();

    if (user  && user.id && (user.id === 1 || user.id === 12 || user.id === 104846 || environment.env === 'train' && user.id === 4)) {
      return true;
    } else {
      this.router.navigate(['/login']).then();
      return false;
    }
  }
}
